import React from 'react';
import Layout from '../../core/Layout';
import { Encabezado } from '../../core/Encabezado';
import { DocRow, DocSection, DocMigas } from '../DocComponentes';

class DocumentacionLegal extends React.Component {
    componentDidMount() {
        let event = new Event('js');
        window.dispatchEvent(event);
    }
    render() {
        return (
            <div>
                <Layout title="Red Itmex - Documentación - Legal">
                    <section className="paginaItmex docItmex">
                        <Encabezado
                            etiqueta="Documentación"
                            titulo="Documentación Legal"
                            subtitulo="Documentos regulatorios y contractuales de Red Itmex."
                        />
                        <DocMigas actual="Legal" />

                                    {/* ── Sección 1: Institucionales ── */}
                                    <DocSection
                                        icon="fa-gavel"
                                        title="Documentos Institucionales"
                                        subtitle="Avisos, contratos y códigos de conducta"
                                    >
                                        <DocRow
                                            href="https://www.reditmex.com/documentacion/legal/aviso-atencion-a-usuarios/pdf/v3"
                                            label="Aviso Atención a Usuarios"
                                            version="v3" date="26/07/2024"
                                        />
                                        <DocRow
                                            href="https://www.reditmex.com/documentacion/legal/aviso-mapas-de-cobertura/pdf/v3"
                                            label="Aviso Mapas de Cobertura"
                                            version="v3" date="26/07/2024"
                                        />
                                        <DocRow
                                            href="https://www.reditmex.com/documentacion/legal/titulo-de-concesion/pdf/v3"
                                            label="Título de Concesión"
                                            version="v3" date="26/07/2024"
                                        />
                                        <DocRow
                                            href="https://www.reditmex.com/documentacion/legal/colaboracion-en-materia-de-seguridad-y-justicia/pdf/v3"
                                            label="Colaboración en Materia de Seguridad y Justicia"
                                            version="v3" date="26/07/2024"
                                        />
                                        <DocRow
                                            href="https://www.reditmex.com/documentacion/legal/lineamientos-de-información-transparente/pdf/v3"
                                            label="Lineamientos de Información Transparente"
                                            version="v3" date="26/07/2024"
                                        />
                                        <DocRow
                                            href="https://www.reditmex.com/documentacion/legal/codigo-de-politicas-de-gestion-de-trafico/pdf/v3"
                                            label="Código de Políticas de Gestión de Tráfico"
                                            version="v3" date="26/07/2024"
                                        />
                                        <DocRow
                                            href="https://www.reditmex.com/documentacion/legal/codigo-de-prácticas-comerciales/pdf/v3"
                                            label="Código de Prácticas Comerciales"
                                            version="v3" date="26/07/2024"
                                        />
                                        <DocRow
                                            href="https://www.reditmex.com/documentacion/legal/aviso-de-privacidad/pdf/v3"
                                            label="Aviso de Privacidad"
                                            version="v3" date="26/07/2024"
                                        />
                                        <DocRow
                                            href="https://www.reditmex.com/documentacion/legal/carta-de-derechos-mínimos-de-los-usuarios/pdf/v3"
                                            label="Carta de Derechos Mínimos de los Usuarios"
                                            version="v3" date="26/07/2024"
                                        />
                                        <DocRow
                                            href="https://www.reditmex.com/documentacion/legal/contrato-de-adhesion/pdf/v3"
                                            label="Contrato de Adhesión"
                                            version="v3" date="26/07/2024"
                                        />
                                        <DocRow
                                            href="https://www.reditmex.com/documentacion/legal/procedimiento-de-atencion-de-dudas-aclaraciones-quejas-y-reclamaciones/pdf/v3"
                                            label="Procedimiento de Atención de Dudas, Aclaraciones, Quejas y Reclamaciones"
                                            version="v3" date="26/07/2024"
                                        />
                                    </DocSection>

                                    {/* ── Sección 2: Planes Wireless ── */}
                                    <DocSection
                                        icon="fa-satellite-dish"
                                        title="Planes Wireless"
                                        subtitle="Formatos simplificados y características de planes inalámbricos"
                                    >
                                        <DocRow
                                            href="https://www.reditmex.com/documentacion/legal/caracteristicas-especificaciones-y-alcances-de-paquetes-de-internet-wireless/pdf/v3"
                                            label="Características, Especificaciones y Alcances — Internet Wireless"
                                            version="v3" date="26/07/2024"
                                        />
                                        <DocRow
                                            href="https://www.reditmex.com/documentacion/legal/formato-simplificado-536878-plan-basico/pdf/v3"
                                            label="Formato Simplificado 536878 — Plan Básico"
                                            version="v3" date="26/07/2024"
                                        />
                                        <DocRow
                                            href="https://www.reditmex.com/documentacion/legal/formato-simplificado-536888-plan-premium/pdf/v3"
                                            label="Formato Simplificado 536888 — Plan Premium"
                                            version="v3" date="26/07/2024"
                                        />
                                        <DocRow
                                            href="https://www.reditmex.com/documentacion/legal/formato-simplificado-536892-plan-gold/pdf/v3"
                                            label="Formato Simplificado 536892 — Plan Gold"
                                            version="v3" date="26/07/2024"
                                        />
                                        <DocRow
                                            href="https://www.reditmex.com/documentacion/legal/formato-simplificado-536901-plan-gamer/pdf/v3"
                                            label="Formato Simplificado 536901 — Plan Gamer"
                                            version="v3" date="26/07/2024"
                                        />
                                    </DocSection>

                                    {/* ── Sección 3: Planes Fibra Óptica ── */}
                                    <DocSection
                                        icon="fa-wifi"
                                        title="Planes Fibra Óptica"
                                        subtitle="Formatos simplificados y características de planes de fibra"
                                    >
                                        <DocRow
                                            href="https://www.reditmex.com/documentacion/legal/caracteristicas-especificaciones-y-alcances-de-paquetes-de-internet-fibra-optica/pdf/v3"
                                            label="Características, Especificaciones y Alcances — Internet Fibra Óptica"
                                            version="v3" date="26/07/2024"
                                        />
                                        <DocRow
                                            href="https://www.reditmex.com/documentacion/legal/formato-simplificado-1347530-plan-basico-plus/pdf/v3"
                                            label="Formato Simplificado 1347530 — Plan Básico +"
                                            version="v3" date="26/07/2024"
                                        />
                                        <DocRow
                                            href="https://www.reditmex.com/documentacion/legal/formato-simplificado-1347531-plan-premium-plus/pdf/v3"
                                            label="Formato Simplificado 1347531 — Plan Premium +"
                                            version="v3" date="26/07/2024"
                                        />
                                        <DocRow
                                            href="https://www.reditmex.com/documentacion/legal/formato-simplificado-1347543-plan-gold-plus/pdf/v3"
                                            label="Formato Simplificado 1347543 — Plan Gold +"
                                            version="v3" date="26/07/2024"
                                        />
                                        <DocRow
                                            href="https://www.reditmex.com/documentacion/legal/formato-simplificado-1347545-plan-gamer-plus/pdf/v3"
                                            label="Formato Simplificado 1347545 — Plan Gamer +"
                                            version="v3" date="26/07/2024"
                                        />
                                        <DocRow
                                            href="https://www.reditmex.com/documentacion/legal/formato-simplificado-1347564-plan-basico-plus-simetrico/pdf/v3"
                                            label="Formato Simplificado 1347564 — Plan Básico + Simétrico"
                                            version="v3" date="26/07/2024"
                                        />
                                        <DocRow
                                            href="https://www.reditmex.com/documentacion/legal/formato-simplificado-1347566-plan-premium-plus-simetrico/pdf/v3"
                                            label="Formato Simplificado 1347566 — Plan Premium + Simétrico"
                                            version="v3" date="26/07/2024"
                                        />
                                        <DocRow
                                            href="https://www.reditmex.com/documentacion/legal/formato-simplificado-1347567-plan-gold-plus-simetrico/pdf/v3"
                                            label="Formato Simplificado 1347567 — Plan Gold + Simétrico"
                                            version="v3" date="26/07/2024"
                                        />
                                        <DocRow
                                            href="https://www.reditmex.com/documentacion/legal/formato-simplificado-1347568-plan-gamer-plus-simetrico/pdf/v3"
                                            label="Formato Simplificado 1347568 — Plan Gamer + Simétrico"
                                            version="v3" date="26/07/2024"
                                        />
                                        <DocRow
                                            href="https://www.reditmex.com/documentacion/legal/formato-simplificado-1347559-plan-empresarial-plus/pdf/v3"
                                            label="Formato Simplificado 1347559 — Plan Empresarial +"
                                            version="v3" date="26/07/2024"
                                        />
                                    </DocSection>

                    </section>
                </Layout>
            </div>
        )
    }
}

export default DocumentacionLegal;
